<h2>Igangværende ordre</h2>
<table mat-table [dataSource]="activeServiceordrer" class="mat-elevation-z0">
  <ng-container matColumnDef="deadline">
    <th mat-header-cell *matHeaderCellDef>Deadline</th>
    <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.deadline | date : 'dd.MM.yyyy' }}</td>
  </ng-container>

  <ng-container matColumnDef="interval">
    <th mat-header-cell *matHeaderCellDef>Serviceinterval</th>
    <td mat-cell *matCellDef="let serviceordre">
      {{ serviceordre.serviceintervalStart | date : 'dd.MM.yyyy' }} - {{ serviceordre.serviceintervalEnd | date : 'dd.MM.yyyy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ordrenr">
    <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
    <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.serviceordreNo }}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Opgave</th>
    <td mat-cell *matCellDef="let serviceordre">
      <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
        {{ serviceordre.opgaveDisplayText }}
        @if (getNotes(serviceordre)) {
          <mat-icon
            class="material-icons cursor-help"
            svgIcon="note"
            [matTooltip]="getNotes(serviceordre)"
          ></mat-icon>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let serviceordre">
      @if (serviceordre.serviceordreStateEnum === serviceordreStatusEnum.ValidationFailed) {
        <button type="button" class="btn-icon orange" (click)="handleValidationFailed($event, serviceordre)">
          <mat-icon svgIcon="obs-solid"></mat-icon>
          <span>{{ serviceordre.serviceordreStateUserText }}</span>
        </button>
      }
      @if (serviceordre.serviceordreStateEnum != serviceordreStatusEnum.ValidationFailed) {
        {{ serviceordre.serviceordreStateUserText }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="partner">
    <th mat-header-cell *matHeaderCellDef>Partner</th>
    <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.partner.name }}</td>
  </ng-container>

  <ng-container matColumnDef="changed">
    <th mat-header-cell *matHeaderCellDef>Ændret</th>
    <td mat-cell *matCellDef="let serviceordre">
      <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
        {{ serviceordre.modifiedOn | date : 'dd.MM.yyyy' }}
        <mat-icon
          class="material-icons cursor-help"
          matTooltip="{{ serviceordre.modifiedOn | date : 'dd.MM.yyyy HH:mm' }} af {{ serviceordre.modifiedBy }}"
          svgIcon="avatar"
        ></mat-icon>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="created">
    <th mat-header-cell *matHeaderCellDef>Oprettet</th>
    <td mat-cell *matCellDef="let serviceordre">
      <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
        {{ serviceordre.createdOn | date : 'dd.MM.yyyy' }}
        <mat-icon
          class="material-icons cursor-help"
          matTooltip="{{ serviceordre.createdOn | date : 'dd.MM.yyyy HH:mm' }} af {{ serviceordre.createdBy }}"
          svgIcon="avatar"
        ></mat-icon>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="activeColumns"></tr>
  <tr mat-row [routerLink]="['/ordre', row.serviceordreNo, 'edit']" *matRowDef="let row; columns: activeColumns"></tr>
</table>

@if (activePage < activePageCount) {
  <div class="align-center margin-top-x2">
    <button type="button" mat-raised-button color="accent" (click)="moreActive()">Vis flere igangværende ordrer</button>
  </div>
}

@if (pastServiceordrer.length > 0) {
  <h2 class="margin-top-x2">Gennemførte ordre</h2>
  <table mat-table [dataSource]="pastServiceordrer" class="mat-elevation-z0">
    <ng-container matColumnDef="ordrenr">
      <th mat-header-cell *matHeaderCellDef>Ordrenr.</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.serviceordreNo }}</td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Opgave</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.opgaveDisplayText }}
          @if (serviceordre.description) {
            <mat-icon
              class="material-icons cursor-help"
              svgIcon="note"
              matTooltip="{{ serviceordre.description }}"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">{{ serviceordre.serviceordreStateUserText }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef>Partner</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.partner.name }}
          @if (serviceordre.partnerafregningBilagsnr) {
            <mat-icon
              class="material-icons"
            matTooltip="Parter er afregnet {{ serviceordre.partnerafregningBeloebExclMoms | dkCurrency }} på bilag {{
              serviceordre.partnerafregningBilagsnr
            }}"
              svgIcon="table"
            ></mat-icon>
          }
          @if (serviceordre.partner.id !== serviceordre.originalPartnerId) {
            <mat-icon
              class="material-icons"
              matTooltip="Oprindelig partner var {{ serviceordre.originalPartnerName }}"
              svgIcon="directions-left-right"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="leveringsdato">
      <th mat-header-cell *matHeaderCellDef>Leveringsdato</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.leveringsdato | date : 'dd.MM.yyyy' }}</td>
    </ng-container>
    <ng-container matColumnDef="modified">
      <th mat-header-cell *matHeaderCellDef>Ændret</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.modifiedOn | date : 'dd.MM.yyyy' }}
          <mat-icon
            class="material-icons cursor-help"
            matTooltip="{{ serviceordre.modifiedOn | date : 'dd.MM.yyyy HH:mm' }} af  {{ serviceordre.modifiedBy }}"
            svgIcon="avatar"
          ></mat-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Oprettet</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.createdOn | date : 'dd.MM.yyyy' }}
          <mat-icon
            class="material-icons cursor-help"
            matTooltip="{{ serviceordre.createdOn | date : 'dd.MM.yyyy HH:mm' }} af  {{ serviceordre.createdBy }}"
            svgIcon="avatar"
          ></mat-icon>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="pastColumns"></tr>
    <tr mat-row [routerLink]="['/ordre', row.serviceordreNo, 'edit']" *matRowDef="let row; columns: pastColumns"></tr>
  </table>
}

@if (pastPage < pastPageCount) {
  <div class="align-center margin-top-x2">
    <button type="button" mat-raised-button color="accent" (click)="morePast()">Vis flere gennemførte ordrer</button>
  </div>
}
